// extracted by css-extract-rspack-plugin
export default {"lazyVideoSpinner":"_d0b8b193"};